import React from 'react'
import { useActions } from 'kea'

import I18n from 'lib/i18n'
import BreakOnBr from 'lib/tags/break-on-br'

import sceneLogic from '~/scenes/pages/request/logic'

const ThankYou = () => {
  const { restart } = useActions(sceneLogic)

  const navigateToStart = event => {
    event.preventDefault()
    restart()
  }

  return (
    <div className='thank-you'>
      <h1>{I18n.t('react.request.thank_you.title')}</h1>
      <p>
        <BreakOnBr text={I18n.t('react.request.thank_you.subtitle')} />
      </p>
      <div className='restart'>
        <a href='#' onClick={navigateToStart} title='restart the whole process'>
          {I18n.t('react.request.request.restart')}
        </a>
      </div>
    </div>
  )
}

export default ThankYou
